export function popupInit() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    $('[data-popup-open]').click(function(e) {
        e.preventDefault();
        $('.popup__bg').fadeIn(800);
        $('html').addClass('no-scroll');
        $('body').css('padding-right', scrollbarWidth);
        $('.et-mobile-panel-wrapper').css('z-index', 0);
        $('.back-top').css('z-index', 0);
        // setInputsWrapperHeight();
    });

    $('[data-popup-close]').click(function() {
        $('.popup__bg').fadeOut(800);
        $('html').removeClass('no-scroll');
        $('body').css('padding-right', 0);
        $('.et-mobile-panel-wrapper').css('z-index', 10);
        $('.back-top').css('z-index', 999);
    });

    // $(window).on('resize', function() {
    //     setInputsWrapperHeight();
    // });

    // $('.store-form-inputs-wrapper').on('scroll', function() {
    //     const mediaQuery = window.matchMedia('(max-width: 768px)');
    //     if (mediaQuery.matches){
    //         setInputsWrapperHeight();
    //     }
    // });

    // $('.popup__content').on('scroll', function() {
    //     const mediaQuery = window.matchMedia('(max-width: 768px)');
    //     if (mediaQuery.matches){
    //         setInputsWrapperHeight();
    //     }
    // });

    $('.wpcf7').on('wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed wpcf7submit', function(e) {

        // stop any ongoing animation, show the element, then start the timeout to hide it
        $('.store-form-response-wrapper').stop(true, true).show();

        // existing timeout function
        setTimeout(function() {
            // setInputsWrapperHeight();
        }, 2000);

        // hide the store-form-response-wrapper again after 5 seconds
        setTimeout(function() {
            $('.store-form-response-wrapper').stop(true, true).hide();
        }, 5000);
    });
}

// function setInputsWrapperHeight() {
//     const mediaQuery = window.matchMedia('(max-width: 768px)');
//
//     if (mediaQuery.matches) {
//         // The viewport is 768px or less
//         const headerHeight = $('.store-form-header').outerHeight(true);
//         const footerHeight = $('.store-form-footer').outerHeight(true);
//         console.log('footerHeight' + footerHeight)
//
//         // Calculate the max height
//         const maxHeight = $(window).innerHeight() - headerHeight - footerHeight;
//
//         // Apply the max height to the wrapper
//         $('.store-form-inputs-wrapper').css('max-height', maxHeight + 'px');
//     }
// }